import Vue from 'vue'
import Vuex from 'vuex'
 
import perfilStore from '@/modules/loja/perfil/perfil.store'
import produtoStores from '@/modules/loja/produto/produto.store'
import menuStores from '@/modules/loja/menu/menu.store'
import Grade from '@/modules/loja/produto/grade/grade.store'
Vue.use(Vuex)

const modules = {
  ...perfilStore,
  ...produtoStores,
  ...menuStores,
  ...Grade
}

export default new Vuex.Store({
  modules
})
